export enum DecisionEnum {
  validee = 1,
  validee_partiellement = 2,
  refus = 3
}
